<template>
  <!-- 新闻内容 -->
  <div class="news_cont_zong">
    <div class="item2">
      <div class="item2_cont" v-if="arrList.length>0">
        <div
          class="item2_cont1"
          v-for="(item, index) in arrList"
          :key="index"
          @click="funUrl(item.id)"
        >
          <img :src="item.image_input[0]" alt="" />
          <div class="item2_cont1_text">
            <div class="item2_cont1_text_top">
              <h1>
                {{ item.title }}
              </h1>
              <p>
                {{ item.synopsis }}
              </p>
            </div>
            <div class="item2_cont1_text_btm">
              <div>{{ item.add_time }}</div>
              <p>查看更多></p>
            </div>
          </div>
        </div>
      </div>
      <div class="news_no_data" v-else>
        亲，没有更多数据了...
      </div>
      <div class="news_page">
        <span class="news_page_btn news_page_cur" @click="switchPage(0)">首页</span>
        <span class="news_page_btn news_page_up" @click="switchPage(1)">上一页</span>
        <span class="news_page_btn news_page_down" @click="switchPage(2)">下一页</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arrList: [],
      currentPage:1
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    switchPage(type){
      if(type==0){
        this.currentPage = 1;
      }else if(type==1){
        if(this.currentPage>1){
          this.currentPage--;
        }
      }else{
        this.currentPage++;
      }
      this.getNewsList();
    },
    getNewsList()  {
      let params = {
        page:this.currentPage,
        limit:10
      }
      this.reqApi.getNewsListInfo(params,(res) => {
        console.log('新闻列表',res);
        this.arrList = res;
      },(err)=>{
        console.log(err)
      })
    },
    funUrl(index) {
      this.$router.push({ path: "/newsDetail", query: { newsId: index } });
    },
  },
};
</script>

<style scoped>
/* 新闻列表 */
.news_no_data{
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  height: 100px;
  text-align: center;
  color: #8f8f8f;
}
.news_page{
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 10px 0;
}
.news_page_btn{
  border: 1px solid #eb7d7d;
  padding: 2px 10px;
}
.news_page_cur{
  margin-right: 20px;
}
.news_page_up{
  margin-right: 20px;
}
.item_cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
}
.item2_cont1:first-child {
  display: flex;
  width: 1200px;
  height: 252px;
  background: #ffffff;
  box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.11);
}

.item_cont1 img {
  margin: 32px 48px 32px 32px;
  width: 300px;
  height: 188px;
  border: dashed;
}
.item_cont1_text {
  width: 868px;
}
.item_cont1_text_top {
  margin: 45px 0 16px 0;
  width: 732px;
  height: 112px;

  border-bottom: 1px solid #eaeaea;
}
.item_cont1_text_top > h1 {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #23337f;
  line-height: 24px;
}
.item_cont1_text_top p {
  margin-top: 16px;
  width: 732px;
  height: 56px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.item_cont1_text_btm {
  width: 732px;

  display: flex;
  justify-content: space-between;
}
.item_cont1_text_btm div {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #23337f;
  line-height: 28px;
}
.item_cont1_text_btm p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #23337f;
  line-height: 28px;
}
/* item2 */
.item2_cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 30px;
}
.item2_cont1 {
  margin-top: 30px;
  display: flex;
  width: 1200px;
  height: 252px;

  background: #f8f8f8;
  box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.11);
}

.item2_cont1 img {
  margin: 32px 48px 32px 32px;
  width: 300px;
  height: 188px;
  border: dashed;
}
.item2_cont1_text {
  width: 868px;
}
.item2_cont1_text_top {
  margin: 45px 0 16px 0;
  width: 732px;
  height: 112px;

  border-bottom: 1px solid #eaeaea;
}
.item2_cont1_text_top > h1 {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;

  color: #3f3f3f;
  line-height: 24px;
}
.item2_cont1_text_top p {
  margin-top: 16px;
  width: 732px;
  height: 56px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.item2_cont1_text_btm {
  width: 732px;

  display: flex;
  justify-content: space-between;
}
.item2_cont1_text_btm div {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  color: #999999;
  line-height: 28px;
}
.item2_cont1_text_btm p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #23337f;
  line-height: 28px;
}
</style>
